import React, { useState, useEffect } from "react";
import Base from "../Employee_components/Employee_Base";
import { Breadcrumbs, Link, Typography } from "@mui/material";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import "./ViewEmployee.css";
import { useParams } from "react-router-dom";
import UseAxios from "../Auth/UseAxios";
import { EMPLOYEE_API_BASE_URL } from "../Auth/Api";

const ViewEmployee = () => {
  const [employee, setEmployee] = useState(null); // Ensure it's null initially
  const { id } = useParams();
  const api = UseAxios();

  useEffect(() => {
    if (id) {
      fetchEmployee();
    }
  }, [id]); // Ensure `id` is included as a dependency

  const fetchEmployee = async () => {
    try {
      const response = await api.get(`${EMPLOYEE_API_BASE_URL}/employee/get-employee/${id}`);
      setEmployee(response.data); // Ensure API response matches structure
      console.log("Employee Data:", response.data);
    } catch (error) {
      console.error("Error fetching employee details:", error);
    }
  };

  if (!employee) {
    return (
      <Base>
        <h2 className="text-center fw-bold" style={{ color: "darkslategrey" }}>
          Loading Employee Details...
        </h2>
      </Base>
    );
  }

  return (
    <Base>
      <div className="pt-3 mt-5" style={{ display: "flex", justifyContent: "flex-end", paddingRight: "20px" }}>
        <Breadcrumbs separator={<NavigateNextIcon fontSize="small" />} aria-label="breadcrumb">
          <Link  color="inherit" href="/employee/dashboard" sx={{ color: "blue", fontWeight: "bold" }}>
            Dashboard
          </Link>
          <Link  color="inherit" href="/employee/employee_list" sx={{ color: "blue", fontWeight: "bold" }}>
            EmployeeList
          </Link>
        </Breadcrumbs>
      </div>

      <h2 className="text-center fw-bold fs-1" style={{ color: "darkslategrey" }}>Employee Details</h2>
      <div style={{ display: "flex", justifyContent: "center" }}>
        <hr style={{ width: "70%" }} />
      </div>

      <div className="center-container">
        <div className="view-card">
          <Typography variant="h5" color="success" style={{ fontWeight: "bolder" }} gutterBottom>
            {employee.id}. {employee.fullName}
          </Typography>
          <hr />

          <div className="row">
            <div className="col-md-12">
              {[
                { label: "Employee refernce id", value: id },
                { label: "Email", value: employee.email },
                { label: "Designation", value: employee.designation }, // Fix field name if different in API
                { label: "Mobile", value: employee.mobile },
                { label: "Branch", value: employee.location },
                { label: "Address", value: employee.address },
                { label: "Date of Birth", value: employee.dateOfBirth ? employee.dateOfBirth.split("T")[0] : "N/A" }
              ].map(({ label, value }) => (
                <div className="row pt-2" key={label}>
                  <div className="col-md-6">
                    <h6>{label}:</h6>
                  </div>
                  <div className="col-md-6">
                    <h6 className="text-primary">{` ${value || "N/A"}`}</h6>
                  </div>                 
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </Base>
  );
};

export default ViewEmployee;
